module.exports = __webpack_public_path__ + "img/QR.cc94f163.png";